import { useLocation } from "react-router-dom";

export const GetUrlParam = (param: string) => {
    let location = useLocation();
    let params = new URLSearchParams(location.search);
    let paramBool = params.get(param) === 'true';
    return paramBool;
};

export const GetLocalStorageByKey = (key: string) => {
    return JSON.parse(localStorage.getItem(key)!);
}

export const GetBasePath = () => {
    return process.env.REACT_APP_BASE_BASEPATH;
}

export const SetPostMessageListener = (setAuth: Function) => {
    const urls = process.env.REACT_APP_ALLOWED_URLS?.split(',');
    const messageListener = (e: any) => {
        if (urls?.includes(e.origin)) {

            if (e?.data?.auth) {
                localStorage.setItem('Authorization', e.data.auth);
                localStorage.setItem('onlybody', e.data.onlybody);
                localStorage.setItem('hidetabs', e.data.hidetabs);
                window.parent.postMessage({ pageLoaded: true }, '*');
                setAuth(true);
                if (GetGoBackFlag()) {
                    window.history.back();
                    SetGoBackFlag('false');
                }
            }
            // if (navigate) {
            //   navigate(event.data.path);
            // }

            // if (e?.data && e?.data?.type == 'updateViewModel') {
            //     console.log(e.data.viewModel);
            // }
        }
    }

    window.removeEventListener('message', messageListener);
    window.addEventListener("message", messageListener, false);
}

export const GetGoBackFlag = () => {
    return JSON.parse(sessionStorage.getItem('goBack')!);
}

export const SetGoBackFlag = (bool: string) => {
    sessionStorage.setItem('goBack', bool);
}

export const convertFirstLetterToLowerCase = (str: string) => {
    if (str.length === 0) {
        return str;
    }

    var firstLetterLowerCase = str.charAt(0).toLowerCase();
    var remainingString = str.slice(1);  // Prende tutti i caratteri dopo il primo

    return firstLetterLowerCase + remainingString;
};

export const getEnumKeys = <T extends Record<string, unknown>>(
    enumToDeconstruct: T
  ): Array<keyof typeof enumToDeconstruct> => {
    return Object.keys(enumToDeconstruct) as Array<keyof typeof enumToDeconstruct>;
  };